module.exports = __webpack_public_path__ + "img/icon-hospital.b5a38656.gif";